import React from 'react'

import { Hotkey } from '@tribeplatform/react-ui-kit/Hotkey'
import { SvgIcon, SvgIconName } from '@tribeplatform/react-ui-kit/Icon'

export type KeyLabel =
  | {
      type: 'hotkey' | 'label'
      value: string
    }
  | {
      type: 'icon'
      value: SvgIconName
    }

export interface HotkeyGuideItemProps {
  keyLabels: KeyLabel[]
  description: React.ReactNode
  onClick?: () => void
  className?: string
}

export const HotkeyGuideItem: React.FC<HotkeyGuideItemProps> = ({
  keyLabels,
  description,
  onClick,
  className = '',
}) => {
  const baseContainerClasses = 'flex gap-1 items-center shrink-0'
  const baseKeyClasses =
    ' h-6 px-2 flex items-center justify-center rounded-md bg-surface border'
  const interactiveClasses = onClick ? 'cursor-pointer hover:opacity-85' : ''
  const combinedClasses =
    `${baseContainerClasses} ${interactiveClasses} ${className}`.trim()

  const renderKeyLabel = (keyLabel: KeyLabel, index: number) => {
    switch (keyLabel.type) {
      case 'icon':
        return (
          <div key={index} className={`${baseKeyClasses} w-6 aspect-square`}>
            <SvgIcon name={keyLabel.value} />
          </div>
        )
      case 'hotkey':
        return (
          <Hotkey
            key={index}
            className={`${baseKeyClasses} [&>kbd]:text-xs aspect-square`}
          >
            {keyLabel.value}
          </Hotkey>
        )
      case 'label':
        return (
          <span key={index} className={`${baseKeyClasses} [&>kbd]:text-xs`}>
            {keyLabel.value}
          </span>
        )
      default:
        return null
    }
  }

  return (
    <div className={combinedClasses} onClick={onClick}>
      {keyLabels.map((keyLabel, index) => renderKeyLabel(keyLabel, index))}
      <span>{description}</span>
    </div>
  )
}
